import React, {useState} from "react";
import FormattedDate from "./FormattedDate";
import WeatherTemperature from "./WeatherTemperature";
import WeatherIcon from "./WeatherIcon";
import DailyWeather from "./DailyWeather";
import axios from "axios";
import "./Weather.css";

export default function Weather(props){
    let [city, setCity] = useState (props.city);
    let [ready, setReady] = useState(false);
    let [weather, setWeather]= useState("");
    
    function showTemperature(response){
        setWeather({
            coordinates: response.data.coord,
           temperature: response.data.main.temp,
           wind: response.data.wind.speed,
           date: new Date(response.data.dt * 1000),
           humidity: response.data.main.humidity,
           city: response.data.name,
           icon: response.data.weather[0].icon,
           description: response.data.weather[0].description
       });
       setReady(true);

    }

function search(){
    let apiKey="fe19f9593afb0f5920433f0e9f5f1132";
    let apiUrl=`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(showTemperature);

}
function handleSubmit(event){
    event.preventDefault();
    search();

}
function handleCity(event){
    setCity(event.target.value);

}

    if (ready) {
        return (
        <div className="Weather">
        <form onSubmit={handleSubmit}>
            <div className="row">
            <div className="col-9">
            <input type="search" placeholder="Enter a city" className="form-control" autoFocus="on" onChange={handleCity}/>
           </div>
            <div className="col-3">
            <input type="submit" value="Search" className="btn btn-primary w-100"/>
            </div>
            </div>
        </form>
        
        <h1>{weather.city}</h1>
        <ul>
            <li>
                <FormattedDate date={weather.date} />
                </li>
            <li className="text-capitalize">{weather.description}</li>
        </ul>
        <div className="row mt-3">
            <div className="col-6">
                    <div className="d-flex">
                        <div>
            <WeatherIcon code={weather.icon} size={52} />
            </div>
            <div>
            <WeatherTemperature celsius={weather.temperature}/>
            
            </div>
           </div>
           
           </div>
            <div className="col-6">
                <ul>
                    <li>Humidity: {weather.humidity}%</li>
                    <li>Wind: {weather.wind}km/h</li>
                </ul>
            </div>
            <DailyWeather coordinates={weather.coordinates}/>
            </div>
    </div> );
}
else {
    search();
    return "Loading...";
}
}